module.exports = __webpack_public_path__ + "static/img/cont59 (4).ff5e7b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (4).jpg
// module id = vOLh
// module chunks = 0